import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/close.svg'


const _withScopeId = n => (_pushScopeId("data-v-939aa116"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-font-normal" }
const _hoisted_2 = ["data-cy"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "tw-w-3 tw-h-3",
  src: _imports_0,
  alt: "close"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`${_ctx.isHeader} tw-flex tw-justify-between tw-items-center tw-w-full tw-text-[#211f58] ${
      _ctx.isHeader === ''
        ? 'tw-px-[20px] tw-py-5 sm:tw-px-10'
        : 'tw-pl-10 tw-pt-5 tw-pr-5 tw-pb-2'
    } tw-border-b-[#EFF0F1] tw-border-b ${
      _ctx.title ? 'profileModal-header' : ''
    } ${_ctx.classHeader}`)
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(`tw-text-[18px] tw-font-semibold profileModal-header__title ${_ctx.className}`)
    }, [
      _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
      _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.subTitle), 1),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ], 2),
    (!_ctx.hideClose)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "profileModal-header__close",
          "data-cy": _ctx.dataCyClose,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_4, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ], 2))
}